import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=4c6b8219&scoped=true&"
import script from "./integration.vue?vue&type=script&lang=js&"
export * from "./integration.vue?vue&type=script&lang=js&"
import style0 from "./integration.vue?vue&type=style&index=0&id=4c6b8219&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b8219",
  null
  
)

export default component.exports